import { store } from '../lib/store';
import WPJSApi from "../lib/includes/wpjswrapper";

let WPJSSearch = WPJSApi.create('lejon', 'search');

//Code that runs in app.js
export const init = () => {


	window.addEventListener('scroll', () => {

		if (window.pageYOffset > 35) {
			if(!store.getState().customState.scrolled) {
				store.dispatch({
					type: 'PAGE_SCROLLED',
					scrolled: true
				})
			}
		} else {
			if (store.getState().customState.scrolled) {
				store.dispatch({
					type: 'PAGE_SCROLLED',
					scrolled: false
				})
			}
		}
	});

};

export const loadPosts = (dispatch) => {


	let page = (store.getState().newsState.page ?? 0) + 1;
	let per_page = 6;
	let args = { page: page, per_page: per_page, _envelope: 1};

	WPJSApi.Posts.list(args).then((rsp) => {
		if (rsp.status === 400) {
			dispatch({
				type: 'NEWS_FULL'
			})
		} else {
			dispatch({
				type: 'NEWS_LOADED',
				news: rsp.body,
				page: page
			});

			if (rsp.headers['X-WP-TotalPages'] === page) {
				dispatch({
					type: 'NEWS_FULL'
				})
			}
		}

	});




}

export const setModal = (content) => {

	store.dispatch({
		type: 'SET_MODAL',
		modal_content: content,
	})

}

export const setMyBuilding = (slug, title) => {

	let slugs = [];
	if (store.getState().buildingState.building_slugs) {
		slugs = store.getState().buildingState.building_slugs;
	}

	let slugIndex = slugs.map(building => building.slug).indexOf(slug);

	if (slugIndex >= 0) {
		slugs = slugs.slice(0, slugIndex).concat(slugs.slice(slugIndex + 1));
	} else {
		slugs = slugs.concat([{slug: slug, title: title}]);
	}

	slugs = slugs.sort((a, b) => a.title.localeCompare(b.title));

	store.dispatch({
		type: 'BUILDING_SET',
		slugs: slugs
	})

	window.localStorage.setItem('lejonfastigheter_my_buildings', JSON.stringify(slugs));
}

if (window.localStorage.getItem('lejonfastigheter_my_buildings') !== null) {

	let slugs = null;
	try {
		slugs = JSON.parse(window.localStorage.getItem('lejonfastigheter_my_buildings'));
	} catch {
		window.localStorage.removeItem('lejonfastigheter_my_buildings');
	}
	if (slugs !== null) {
		store.dispatch({
			type: 'BUILDING_SET',
			slugs: slugs
		})
	}

}

export const searchSite = () => {

	let search = store.getState().searchState.searchString;

	//Viewstate: 0 = suggesting, 1 = searched
	store.dispatch({
		type: 'SEARCH_CHANGED',
		search: search
	})

	if (search && search.length > 2) {


		store.dispatch({
			type: 'SEARCH_LOADING'
		})

		WPJSSearch.list({ search: search }).then((rsp) => {
			store.dispatch({
				type: 'SEARCH_LOADED',
				result: rsp
			})
		});

	} else {
		store.dispatch({
			type: 'SEARCH_VIEW_DEFAULT'
		})
	}

}